<template>
  <section>
    <h1>Mapping</h1>

    <ul class="steps is-narrow is-medium is-centered has-content-centered">
    <li class="steps-segment">
      <a href="#" class="has-text-dark">
          <span class="steps-marker">
            <span class="icon">
              <i class="fa fa-shopping-cart"></i>
            </span>
          </span>
        <div class="steps-content">
          <p class="heading">Shopping Cart</p>
        </div>
      </a>
    </li>
    <li class="steps-segment">
      <a href="#" class="has-text-dark">
          <span class="steps-marker">
            <span class="icon">
              <i class="fa fa-user"></i>
            </span>
          </span>
        <div class="steps-content">
          <p class="heading">User Information</p>
        </div>
      </a>
    </li>
    <li class="steps-segment is-active has-gaps">
        <span class="steps-marker">
          <span class="icon">
            <i class="fa fa-usd"></i>
          </span>
        </span>
      <div class="steps-content">
        <p class="heading">Payment</p>
      </div>
    </li>
    <li class="steps-segment">
        <span class="steps-marker is-hollow">
          <span class="icon">
            <i class="fa fa-check"></i>
          </span>
        </span>
      <div class="steps-content">
        <p class="heading">Confirmation</p>
      </div>
    </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Mapping',
  props: ['id'],
  data () {
    return {
      loading: false,
      name: '',
      email: ''
    }
  },
  async created () {
    console.log('mapping created event')
    this.getClient()
  },
  methods: {
    async getClient () {
      this.name = 'Client Test'
      this.email = 'client@example.com'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Mapping.vue